<template>
  <div class="document-form-container">
    <div class="page-title-container lighter-shadow document-page-title-container" v-if="!isLoading">
      <i class="fa fa-file-alt icon"></i>

      <LiteButton @click.native="$router.go(-1)"
                  style="font-size: 35px; float: right; margin-top: 30px; margin-left: -45px;"
                  class="edit-button"
                  :hoverColor="'red'"
                  :icon="'far fa-window-close'">
      </LiteButton>

      <h1>{{ document.documentInfo.documentName }}</h1>
      <h2>{{ document.documentInfo.registrationNumber }}</h2>

      <hr class="form-line document-line"/>

      <LiteButton @click.native="shouldEdit = true"
                  class="document-edit-button"
                  v-show="!shouldEdit"
                  :hoverColor="'blue'"
                  :icon="'far fa-edit'">
      </LiteButton>
      <LiteButton @click.native="shouldEdit = false"
                  style="font-size: 28px; margin-bottom: -3px;"
                  class="document-edit-button"
                  v-show="shouldEdit"
                  :hoverColor="'red'"
                  :icon="'far fa-window-close'">
      </LiteButton>

      <div class="last-modified-container document-last-modified-container">
        <p class="last-modified-date" v-text="getLastModifiedDate(document.documentInfo)"></p>
        <p class="last-modified-name" v-text="getLastModifiedBy(document.documentInfo)"></p>
      </div>

      <hr class="form-line document-line"/>

      <div class="document-fields-container" v-if="!shouldEdit">
        <TextField v-if="document.documentInfo.startDate"
                   class="document-field"
                   :label="'Дата на издаване'"
                   :value="formatDate(document.documentInfo.startDate)"/>
        <TextField v-if="document.documentInfo.endDate"
                   class="document-field"
                   :label="'Дата на изтичане'"
                   :value="formatDate(document.documentInfo.endDate)"/>
        <TextField v-for="field in document.fieldDefinitions"
                   class="document-field"
                   :key="field.selector"
                   :label="field.name"
                   :value="getFieldValue(field)"/>
      </div>

      <CarDocumentEditForm  style="margin-bottom: 100px;" v-if="shouldEdit" :document="document" @updated-document="updatedDocument"/>

      <hr class="form-line document-line"/>

      <div class="tab-header-container">
        <h2 class="form-label" style="width: fit-content; margin-left: 30px;">Файлове</h2>
        <LiteButton @click.native="shouldEditFiles = true"
                    class="document-edit-button"
                    v-show="!shouldEditFiles"
                    :hoverColor="'blue'"
                    :icon="'far fa-edit'">
        </LiteButton>
        <LiteButton @click.native="setShouldNotEditFiles"
                    style="font-size: 28px; margin-bottom: -3px;"
                    class="document-edit-button"
                    v-show="shouldEditFiles"
                    :hoverColor="'red'"
                    :icon="'far fa-window-close'">
        </LiteButton>
      </div>

      <hr class="form-line document-line"/>

      <div class="item-container very-light-shadow file-item-container"
           v-for="file in files" :key="file.id">

        <p class="item-label" v-text="file.name + '.' + file.type"></p>

        <LiteButton @click.native="goToFile(file)"
                    class="edit-button info-file-icon"
                    v-show="!shouldEditFiles && file.type === 'pdf'"
                    :hoverColor="'blue'"
                    :icon="'far fa-file-pdf'">
        </LiteButton>

        <LiteButton @click.native="goToFile(file)"
                    class="edit-button info-file-icon"
                    v-show="!shouldEditFiles && file.type !== 'pdf'"
                    :hoverColor="'blue'"
                    :icon="'far fa-file-image'">
        </LiteButton>

        <LiteButton @click.native="removeFile(file)"
                    class="edit-button delete-file-icon"
                    v-show="shouldEditFiles"
                    :hoverColor="'red'"
                    :icon="'far fa-trash-alt'">
        </LiteButton>

        <div class="last-modified-container">
          <p class="last-modified-date" v-text="getLastModifiedDate(file)"></p>
          <p class="last-modified-name" v-text="getLastModifiedBy(file)"></p>
        </div>
      </div>

      <div v-if="shouldEditFiles" class="document-upload-container">

        <DocumentUploader @file-upload="addFile"/>

        <Button class="save-button"
                @click.native="saveFiles"
                :color="'green'"
                :text="'Запази'"
                :icon="'fa fa-save'"></Button>
      </div>
    </div>
  </div>
</template>

<script>
import carDocumentService from "@/services/carDocument.service";
import mapperService from "@/services/mapper.service";
import TextField from "@/shared/components/TextField";
import LiteButton from "@/shared/components/button/LiteButton";
import CarDocumentEditForm from "@/components/car/document/CarDocumentEditForm";
import dateService from "@/services/date.service";
import Button from "@/shared/components/button/Button";
import DocumentUploader from "@/shared/components/form/DocumentUploader";

export default {
  name: "CarDocumentPreview",
  components: {DocumentUploader, Button, CarDocumentEditForm, TextField, LiteButton},
  created() {
    carDocumentService.fetchDocument(this.documentId)
        .then(({data}) => {
          this.document = data;
          this.isLoading = false;
        });
    this.fetchDocumentFiles();
  },
  data() {
    return {
      documentId: this.$route.params.id,
      isLoading: true,
      shouldEdit: false,
      shouldEditFiles: false,
      filesToDelete: [],
      filesToAdd: [],
      document: {},
      files: []
    }
  },
  methods: {
    fetchDocumentFiles() {
      carDocumentService.fetchDocumentFiles(this.documentId)
          .then(({data}) => {
            this.files = data;
          });
    },
    setShouldNotEditFiles() {
      this.shouldEditFiles = false;
      this.filesToAdd = [];
      this.filesToDelete = [];
      this.fetchDocumentFiles();
    },
    getLastModifiedBy(document) {
      return mapperService.getLastModifiedBy(document);
    },
    getLastModifiedDate(document) {
      return mapperService.getLastModifiedDate(document);
    },
    getFieldValue(field) {
      return this.document.fieldValues[field.selector] ? this.document.fieldValues[field.selector] + '' : '-';
    },
    updatedDocument(data) {
      this.document = data;
      this.shouldEdit = false;
    },
    formatDate(date) {
      return dateService.formatDate(date);
    },
    goToFile(file) {
      let routeData = this.$router.resolve({path: `/api/cars/documents/files/${file.id}/download`});
      const route = routeData.href.replace('/app/api', '/api')
      window.open(route, '_blank');
    },
    removeFile(file) {
      this.files = this.files.filter(e => e.id !== file.id);
      this.filesToAdd = this.filesToAdd.filter(e => e.id !== file.id);
      this.filesToDelete.push(file);
    },
    addFile(file) {
      const fileType = file.name.split('.')[1];
      const id = this.randomUUID();
      const fileName = file.name.split('.')[0];
      this.filesToAdd.push({id, file});
      this.files.push({
        id,
        name: fileName,
        type: fileType
      })
    },
    saveFiles() {
      carDocumentService.archiveDocumentFiles(this.filesToDelete)
          .then(() => {
            this.fetchDocumentFiles();
            this.shouldEditFiles = false;
          });
      carDocumentService.uploadFiles(this.documentId, this.filesToAdd.map(file => file.file))
          .then(() => {
            this.fetchDocumentFiles();
            this.shouldEditFiles = false;
          });
      this.filesToAdd = [];
      this.filesToDelete = [];
    },
    randomUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  },
  computed: {
  }
}
</script>

<style scoped>
@import '../../../css/shared/tabs.css';

.document-form-container {
  width: 750px;
  height: calc(100vh - 140px);
  margin: auto;
}

.document-last-modified-container {
  width: fit-content;
  float: right;
  margin-right: 30px;
  margin-top: 10px;
}

.document-line {
  width: calc(100% - 40px);
  margin: 15px;
  display: inline-block;
  box-sizing: border-box;
}

.document-page-title-container {
  text-align: center;
  height: auto;
}

.document-fields-container {
  width: 80%;
  margin: 0 auto 30px auto;
  display: inline-block;
}

.document-field {
  margin: 20px 0;
}

.document-edit-button {
  font-size: 25px;
  height: 25px;
  color: var(--dark-grey);
  display: inline-block;
  margin: 0 30px;
  width: auto;
  float: left;
}

.info-file-icon {
  height: 25px;
  font-size: 25px;
}

.delete-file-icon {
  height: 25px;
  font-size: 25px;
  color: var(--slight-light-red);
}

.file-item-container {
  width: 80%;
  margin: 20px 0;
}

.save-button {
  width: 300px;
  height: 60px;
  font-size: 26px;
  margin: 45px;
}

.document-upload-container {
  width: 80%;
  margin: auto;
}
</style>
